module.exports = __webpack_public_path__ + "static/man-white-d670e715c9cae3d4c76c05c146b53339.jpg";